module.exports = __webpack_public_path__ + "img/انتزاعی.6fbe587b.jpg";